

const KPI = ({ title, value, color }) => (
  <div className="col-md-3">
    <div
      className="card text-white p-3 shadow"
      style={{
        background: `linear-gradient(135deg, ${color}, #00000030)`,
        borderRadius: "0.75rem",
      }}
    >
      <h6>{title}</h6>
      <h3>{value}</h3>
    </div>
  </div>
);

export default KPI;
